import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import api from '../utils/api';
import { useToast } from '../context/ToastContext';

const TABS = [
  { id: 'users',       label: 'المستخدمون' },
  { id: 'branches',    label: 'الفروع' },
  { id: 'territories', label: 'المناطق' },
  { id: 'goals',       label: 'الأهداف' },
  { id: 'commission',  label: 'العمولات' },
  { id: 'sync',        label: 'المزامنة' },
  { id: 'payouts',     label: '💰 حدود العمولة' },
];

const MONTHS_AR = ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];

function getCurrentPeriod() {
  const now = new Date();
  return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
}

function PeriodSelector({ period, onChange }) {
  const periods = [];
  const now = new Date();
  for (let i = -1; i < 6; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    periods.push(d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'));
  }
  return (
    <div style={{ display:'flex', gap:8, overflowX:'auto', paddingBottom:12, marginBottom:12, scrollbarWidth:'none' }}>
      {periods.map(p => (
        <button key={p} style={{ padding:'6px 14px', borderRadius:20, fontSize:13, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap', fontFamily:'var(--font-main)', background:p===period?'var(--primary)':'white', color:p===period?'white':'var(--gray-600)', border:'1.5px solid '+(p===period?'var(--primary)':'var(--gray-200)') }} onClick={() => onChange(p)}>
          {MONTHS_AR[parseInt(p.split('-')[1])-1]}
        </button>
      ))}
    </div>
  );
}

const card = { background:'white', borderRadius:14, padding:'14px 16px', boxShadow:'0 1px 3px rgba(0,0,0,0.08)', border:'1px solid #f3f4f6' };
const modal = { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:500, display:'flex', alignItems:'flex-end', justifyContent:'center' };
const modalContent = { background:'white', borderRadius:'20px 20px 0 0', padding:20, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto' };
const grid2 = { display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 };
const avatarStyle = { width:38, height:38, borderRadius:'50%', background:'linear-gradient(135deg,var(--primary),var(--green-400))', color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:700, flexShrink:0 };

export default function AdminPage() {
  const [tab, setTab] = useState('users');
  const navigate = useNavigate();

  function handleTab(id) {
    if (id === 'payouts') { navigate('/payouts'); return; }
    setTab(id);
  }

  return (
    <div className="page">
      <Header title="الإدارة" />
      <div style={{ display:'flex', background:'white', borderBottom:'1px solid var(--gray-100)', overflowX:'auto', scrollbarWidth:'none' }}>
        {TABS.map(t => (
          <button key={t.id} style={{ flex:1, minWidth:72, padding:'12px 4px', background:'none', border:'none', fontSize:12, cursor:'pointer', fontFamily:'var(--font-main)', whiteSpace:'nowrap', color:tab===t.id?'var(--primary)':'var(--gray-500)', borderBottom:tab===t.id?'2px solid var(--primary)':'2px solid transparent', fontWeight:tab===t.id?700:400 }} onClick={() => handleTab(t.id)}>{t.label}</button>
        ))}
      </div>
      <div className="page-content" style={{ paddingTop:16 }}>
        {tab==='users'       && <UsersTab />}
        {tab==='branches'    && <BranchesTab />}
        {tab==='territories' && <TerritoriesTab />}
        {tab==='goals'       && <GoalsTab />}
        {tab==='commission'  && <CommissionTab />}
        {tab==='sync'        && <SyncTab />}
      </div>
    </div>
  );
}

function UsersTab() {
  const [users, setUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const toast = useToast();
  const rl = { admin:'مدير نظام', sales_manager:'مدير مبيعات', area_supervisor:'مشرف منطقة', supervisor:'مشرف', salesman:'مندوب' };

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    try { const [u,b] = await Promise.all([api.get('/users'),api.get('/branches')]); setUsers(u); setBranches(b); }
    catch { toast.error('خطأ'); } finally { setLoading(false); }
  }
  async function toggle(u) {
    try { await api.post('/users/'+u.id+'/'+(u.active?'deactivate':'activate')); toast.success(u.active?'تعطيل':'تفعيل'); load(); }
    catch(e) { toast.error(e.message); }
  }
  const filtered = users.filter(u => !search || u.username.includes(search)||(u.name_ar||'').includes(search));
  const sups = users.filter(u => ['supervisor','area_supervisor','sales_manager'].includes(u.role));

  return (
    <>
      <div style={{ display:'flex', gap:8, marginBottom:12 }}>
        <input className="input" placeholder="بحث..." value={search} onChange={e=>setSearch(e.target.value)} style={{ flex:1 }} />
        <button className="btn btn-primary btn-sm" onClick={()=>{setEditUser(null);setShowForm(true);}}>+ إضافة</button>
      </div>
      {showForm && <UserForm user={editUser} branches={branches} supervisors={sups} onClose={()=>{setShowForm(false);setEditUser(null);}} onSaved={()=>{setShowForm(false);setEditUser(null);load();}} />}
      {loading ? <div className="loading-page"><div className="spinner"/></div> : (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {filtered.map(u => (
            <div key={u.id} style={{ ...card, opacity:u.active?1:0.6 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={avatarStyle}>{(u.name_ar||u.username||'م').charAt(0)}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:14, fontWeight:700 }}>{u.name_ar||u.name_en}</div>
                  <div style={{ fontSize:12, color:'var(--gray-400)' }}>{u.username} · {rl[u.role]} · NS: {u.netsuite_employee_id||'—'}</div>
                  <div style={{ fontSize:11, color:'var(--gray-400)' }}>{u.branch_name_ar||'—'}</div>
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:4, alignItems:'flex-end' }}>
                  <button className="btn btn-sm btn-outline" style={{ fontSize:11, padding:'4px 10px' }} onClick={()=>{setEditUser(u);setShowForm(true);}}>تعديل</button>
                  <button className="btn btn-sm" style={{ fontSize:11, padding:'4px 10px', background:u.active?'#fee2e2':'var(--green-100)', color:u.active?'#991b1b':'var(--green-700)' }} onClick={()=>toggle(u)}>{u.active?'تعطيل':'تفعيل'}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

function UserForm({ user, branches, supervisors, onClose, onSaved }) {
  const isEdit = !!user;
  const toast = useToast();
  const [saving, setSaving] = useState(false);
  const [f, setF] = useState({ username:user?.username||'', name_ar:user?.name_ar||'', name_en:user?.name_en||'', role:user?.role||'salesman', branch_id:user?.branch_id||'', supervisor_id:user?.supervisor_id||'', netsuite_employee_id:user?.netsuite_employee_id||'', phone:user?.phone||'', password:'' });
  const s = (k,v) => setF(x=>({...x,[k]:v}));
  async function save() {
    if (!f.name_ar||!f.username) { toast.error('الاسم واسم المستخدم مطلوبان'); return; }
    if (!isEdit&&!f.password) { toast.error('كلمة المرور مطلوبة'); return; }
    setSaving(true);
    try {
      const body = { name_ar:f.name_ar, name_en:f.name_en, role:f.role, branch_id:f.branch_id||null, supervisor_id:f.supervisor_id||null, netsuite_employee_id:f.netsuite_employee_id?parseInt(f.netsuite_employee_id):null, phone:f.phone||null };
      if (isEdit) {
        await api.put('/users/'+user.id, { ...body, active:true });
        if (f.password) await api.post('/users/'+user.id+'/reset-password', { password:f.password });
        toast.success('تم تحديث المستخدم');
      } else {
        await api.post('/users', { ...body, username:f.username.toLowerCase().trim(), password:f.password });
        toast.success('تم إنشاء المستخدم');
      }
      onSaved();
    } catch(e) { toast.error(e.message||'خطأ'); } finally { setSaving(false); }
  }
  return (
    <div style={modal}>
      <div style={modalContent}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
          <h3 style={{ fontSize:17, fontWeight:700 }}>{isEdit?'تعديل مستخدم':'إضافة مستخدم جديد'}</h3>
          <button style={{ background:'var(--gray-100)', border:'none', width:30, height:30, borderRadius:'50%', cursor:'pointer', fontSize:14 }} onClick={onClose}>✕</button>
        </div>
        <div style={grid2}>
          <div className="input-group" style={{margin:0}}><label className="input-label">الاسم بالعربي *</label><input className="input" value={f.name_ar} onChange={e=>s('name_ar',e.target.value)} placeholder="محمد أحمد"/></div>
          <div className="input-group" style={{margin:0}}><label className="input-label">بالإنجليزي</label><input className="input" value={f.name_en} onChange={e=>s('name_en',e.target.value)} placeholder="Mohamed"/></div>
          <div className="input-group" style={{margin:0}}><label className="input-label">اسم المستخدم *</label><input className="input" value={f.username} onChange={e=>s('username',e.target.value)} placeholder="m.ahmed" disabled={isEdit}/></div>
          <div className="input-group" style={{margin:0}}><label className="input-label">الدور *</label>
            <select className="input" value={f.role} onChange={e=>s('role',e.target.value)}>
              <option value="salesman">مندوب</option><option value="supervisor">مشرف</option>
              <option value="area_supervisor">مشرف منطقة</option><option value="sales_manager">مدير مبيعات</option>
              <option value="admin">مدير نظام</option>
            </select>
          </div>
          <div className="input-group" style={{margin:0}}><label className="input-label">الفرع</label>
            <select className="input" value={f.branch_id} onChange={e=>s('branch_id',e.target.value)}>
              <option value="">--</option>{branches.map(b=><option key={b.id} value={b.id}>{b.name_ar||b.name_en}</option>)}
            </select>
          </div>
          <div className="input-group" style={{margin:0}}><label className="input-label">المشرف</label>
            <select className="input" value={f.supervisor_id} onChange={e=>s('supervisor_id',e.target.value)}>
              <option value="">--</option>{supervisors.map(s=><option key={s.id} value={s.id}>{s.name_ar||s.username}</option>)}
            </select>
          </div>
          <div className="input-group" style={{margin:0}}><label className="input-label">NetSuite Employee ID</label><input className="input" type="number" value={f.netsuite_employee_id} onChange={e=>s('netsuite_employee_id',e.target.value)} placeholder="12345"/></div>
          <div className="input-group" style={{margin:0}}><label className="input-label">رقم الجوال</label><input className="input" value={f.phone} onChange={e=>s('phone',e.target.value)} placeholder="05x"/></div>
          <div className="input-group" style={{margin:0, gridColumn:'1/-1'}}><label className="input-label">{isEdit?'كلمة مرور جديدة (اختياري)':'كلمة المرور *'}</label><input className="input" type="password" value={f.password} onChange={e=>s('password',e.target.value)} placeholder="8+"/></div>
        </div>
        <div style={{ display:'flex', gap:8, marginTop:16 }}>
          <button className="btn btn-primary" style={{flex:1}} onClick={save} disabled={saving}>{saving?'جاري...':(isEdit?'حفظ التعديلات':'إنشاء المستخدم')}</button>
          <button className="btn btn-secondary" onClick={onClose}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}

function BranchesTab() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const toast = useToast();
  useEffect(() => { load(); }, []);
  async function load() { setLoading(true); try { setBranches(await api.get('/branches')); } catch { toast.error('خطأ'); } finally { setLoading(false); } }
  async function save(id, data) { try { await api.put('/branches/'+id, data); toast.success('تم حفظ الفرع'); setEditId(null); load(); } catch(e) { toast.error(e.message); } }
  async function create(data) { try { await api.post('/branches', data); toast.success('تم إنشاء الفرع'); setShowCreate(false); load(); } catch(e) { toast.error(e.message); } }
  if (loading) return <div className="loading-page"><div className="spinner"/></div>;
  return (
    <>
      <button className="btn btn-primary btn-full" style={{marginBottom:12}} onClick={()=>setShowCreate(true)}>+ إضافة فرع جديد</button>
      {showCreate && (<div style={modal}><div style={modalContent}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
          <h3 style={{ fontSize:17, fontWeight:700 }}>إضافة فرع جديد</h3>
          <button style={{ background:'var(--gray-100)', border:'none', width:30, height:30, borderRadius:'50%', cursor:'pointer' }} onClick={()=>setShowCreate(false)}>✕</button>
        </div>
        <BranchForm branch={{}} onSave={create} onCancel={()=>setShowCreate(false)} isNew/>
      </div></div>)}
      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {branches.map(b => (
          <div key={b.id} style={card}>
            {editId===b.id ? <BranchForm branch={b} onSave={data=>save(b.id,data)} onCancel={()=>setEditId(null)}/> : (
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:15, fontWeight:700 }}>{b.name_ar}</div>
                  <div style={{ fontSize:12, color:'var(--gray-400)' }}>{b.name_en} · {b.city||'—'}</div>
                  <div style={{ fontSize:11, color:'var(--primary)', fontWeight:600 }}>NS Location ID: {b.netsuite_location_id||'—'}</div>
                  <div style={{ fontSize:11, color:'var(--gray-400)' }}>{b.user_count} مستخدم · {b.territory_count} منطقة</div>
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:4, alignItems:'flex-end' }}>
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:8, fontWeight:600, background:b.active?'var(--green-100)':'var(--gray-100)', color:b.active?'var(--green-700)':'var(--gray-500)' }}>{b.active?'نشط':'غير نشط'}</span>
                  <button className="btn btn-sm btn-outline" style={{ fontSize:11, padding:'4px 10px' }} onClick={()=>setEditId(b.id)}>تعديل</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

function BranchForm({ branch, onSave, onCancel, isNew }) {
  const [f,setF]=useState({ name_ar:branch.name_ar||'', name_en:branch.name_en||'', city:branch.city||'', netsuite_location_id:branch.netsuite_location_id||'', active:branch.active!==false });
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  return (
    <div>
      <div style={grid2}>
        <div className="input-group" style={{margin:0}}><label className="input-label">الاسم بالعربي</label><input className="input" value={f.name_ar} onChange={e=>s('name_ar',e.target.value)}/></div>
        <div className="input-group" style={{margin:0}}><label className="input-label">بالإنجليزي</label><input className="input" value={f.name_en} onChange={e=>s('name_en',e.target.value)}/></div>
        <div className="input-group" style={{margin:0}}><label className="input-label">المدينة</label><input className="input" value={f.city} onChange={e=>s('city',e.target.value)}/></div>
        <div className="input-group" style={{margin:0}}><label className="input-label">NetSuite Location ID</label><input className="input" type="number" value={f.netsuite_location_id} onChange={e=>s('netsuite_location_id',e.target.value)} placeholder="123"/></div>
        {!isNew && <div className="input-group" style={{margin:0,gridColumn:'1/-1'}}><label className="input-label">الحالة</label>
          <select className="input" value={f.active?'1':'0'} onChange={e=>s('active',e.target.value==='1')}><option value="1">نشط</option><option value="0">غير نشط</option></select>
        </div>}
      </div>
      <div style={{ display:'flex', gap:8, marginTop:12 }}>
        <button className="btn btn-primary btn-sm" style={{flex:1}} onClick={()=>onSave({...f,netsuite_location_id:f.netsuite_location_id?parseInt(f.netsuite_location_id):null})}>{isNew?'إنشاء':'حفظ'}</button>
        <button className="btn btn-secondary btn-sm" onClick={onCancel}>إلغاء</button>
      </div>
    </div>
  );
}

function TerritoriesTab() {
  const [territories,setTerritories]=useState([]);
  const [branches,setBranches]=useState([]);
  const [users,setUsers]=useState([]);
  const [loading,setLoading]=useState(true);
  const [expanded,setExpanded]=useState(null);
  const [addingUser,setAddingUser]=useState(null);
  const [selUser,setSelUser]=useState('');
  const [showCreate,setShowCreate]=useState(false);
  const [editId,setEditId]=useState(null);
  const toast=useToast();
  useEffect(()=>{load();},[]);
  async function load(){setLoading(true);try{const [t,u,b]=await Promise.all([api.get('/territories'),api.get('/users'),api.get('/branches')]);setTerritories(t);setBranches(b);setUsers(u.filter(u=>u.active&&['salesman','supervisor','area_supervisor'].includes(u.role)));}catch{}finally{setLoading(false);}}
  async function create(data){try{await api.post('/territories',data);toast.success('تم إنشاء المنطقة');setShowCreate(false);load();}catch(e){toast.error(e.message);}}
  async function saveEdit(id,data){try{await api.put('/territories/'+id,data);toast.success('تم الحفظ');setEditId(null);load();}catch(e){toast.error(e.message);}}
  async function assign(tid,uid){try{await api.post('/users/'+uid+'/territories',{territory_id:parseInt(tid)});toast.success('تم التعيين');setAddingUser(null);setSelUser('');load();}catch(e){toast.error(e.message);}}
  async function remove(uid,tid){try{await api.delete('/users/'+uid+'/territories/'+tid);toast.success('تم الإلغاء');load();}catch(e){toast.error(e.message);}}
  if(loading)return <div className="loading-page"><div className="spinner"/></div>;
  return(
    <>
      <button className="btn btn-primary btn-full" style={{marginBottom:12}} onClick={()=>setShowCreate(true)}>+ إضافة منطقة جديدة</button>
      {showCreate&&(<div style={modal}><div style={modalContent}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
          <h3 style={{fontSize:17,fontWeight:700}}>إضافة منطقة جديدة</h3>
          <button style={{background:'var(--gray-100)',border:'none',width:30,height:30,borderRadius:'50%',cursor:'pointer'}} onClick={()=>setShowCreate(false)}>✕</button>
        </div>
        <TerritoryForm territory={{}} branches={branches} onSave={create} onCancel={()=>setShowCreate(false)} isNew/>
      </div></div>)}
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {territories.map(t=>(
          <div key={t.id} style={card}>
            {editId===t.id?(<div><TerritoryForm territory={t} branches={branches} onSave={data=>saveEdit(t.id,data)} onCancel={()=>setEditId(null)}/></div>):(
              <>
                <div style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer'}} onClick={()=>setExpanded(expanded===t.id?null:t.id)}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:15,fontWeight:700}}>{t.name}</div>
                    <div style={{fontSize:12,color:'var(--gray-400)'}}>{t.branch_name_en||'—'} · {t.assigned_user_count} مستخدم</div>
                    <div style={{fontSize:11,color:'var(--primary)',fontWeight:600}}>NS Territory ID: {t.netsuite_territory_id||'—'}</div>
                    <div style={{fontSize:11,color:'var(--gray-400)'}}>عملاء: {t.actual_customer_count}/{t.expected_customer_count}</div>
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:4,alignItems:'flex-end'}}>
                    <button className="btn btn-sm btn-outline" style={{fontSize:11,padding:'4px 10px'}} onClick={e=>{e.stopPropagation();setEditId(t.id);}}>تعديل</button>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--gray-400)" strokeWidth="2" style={{transform:expanded===t.id?'rotate(180deg)':'none',transition:'0.2s'}}><polyline points="6 9 12 15 18 9"/></svg>
                  </div>
                </div>
                {expanded===t.id&&(
                  <div style={{marginTop:12}}>
                    <div className="divider" style={{margin:'0 0 12px'}}/>
                    <p style={{fontSize:13,fontWeight:600,color:'var(--gray-600)',marginBottom:8}}>المستخدمون المعينون</p>
                    {t.users&&t.users.length>0?t.users.map(u=>(<div key={u.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'6px 0',borderBottom:'1px solid var(--gray-100)'}}><div><span style={{fontSize:13,fontWeight:600}}>{u.name_ar||u.username}</span><span style={{fontSize:11,color:'var(--gray-400)',marginRight:6}}> {u.role}</span></div><button className="btn btn-sm" style={{background:'#fee2e2',color:'#991b1b',fontSize:11,padding:'3px 8px'}} onClick={()=>remove(u.id,t.id)}>إلغاء</button></div>)):<p style={{fontSize:12,color:'var(--gray-400)',marginBottom:8}}>لا يوجد مستخدمون</p>}
                    {addingUser===t.id?(<div style={{display:'flex',gap:6,marginTop:8}}><select className="input" style={{flex:1,fontSize:13,padding:'8px 10px'}} value={selUser} onChange={e=>setSelUser(e.target.value)}><option value="">-- اختر --</option>{users.map(u=><option key={u.id} value={u.id}>{u.name_ar||u.username}</option>)}</select><button className="btn btn-primary btn-sm" onClick={()=>selUser&&assign(t.id,selUser)}>تعيين</button><button className="btn btn-secondary btn-sm" onClick={()=>{setAddingUser(null);setSelUser('');}}>إلغاء</button></div>):(<button className="btn btn-outline btn-sm" style={{marginTop:8,width:'100%'}} onClick={()=>{setAddingUser(t.id);setSelUser('');}}>+ تعيين مستخدم</button>)}
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

function TerritoryForm({territory,branches,onSave,onCancel,isNew}){
  const [f,setF]=useState({name:territory.name||'',branch_id:territory.branch_id||'',netsuite_territory_id:territory.netsuite_territory_id||'',expected_customer_count:territory.expected_customer_count||0});
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  return(<div>
    <div style={grid2}>
      <div className="input-group" style={{margin:0,gridColumn:'1/-1'}}><label className="input-label">اسم المنطقة *</label><input className="input" value={f.name} onChange={e=>s('name',e.target.value)}/></div>
      <div className="input-group" style={{margin:0}}><label className="input-label">الفرع</label><select className="input" value={f.branch_id} onChange={e=>s('branch_id',e.target.value)}><option value="">--</option>{branches.map(b=><option key={b.id} value={b.id}>{b.name_ar||b.name_en}</option>)}</select></div>
      <div className="input-group" style={{margin:0}}><label className="input-label">NetSuite Territory ID</label><input className="input" type="number" value={f.netsuite_territory_id} onChange={e=>s('netsuite_territory_id',e.target.value)} placeholder="456"/></div>
      <div className="input-group" style={{margin:0,gridColumn:'1/-1'}}><label className="input-label">عدد العملاء المستهدف</label><input className="input" type="number" value={f.expected_customer_count} onChange={e=>s('expected_customer_count',e.target.value)}/></div>
    </div>
    <div style={{display:'flex',gap:8,marginTop:12}}>
      <button className="btn btn-primary btn-sm" style={{flex:1}} onClick={()=>onSave({...f,branch_id:f.branch_id||null,netsuite_territory_id:f.netsuite_territory_id?parseInt(f.netsuite_territory_id):null,expected_customer_count:parseInt(f.expected_customer_count)||0})}>{isNew?'إنشاء':'حفظ'}</button>
      <button className="btn btn-secondary btn-sm" onClick={onCancel}>إلغاء</button>
    </div>
  </div>);
}

function GoalsTab(){
  const [period,setPeriod]=useState(getCurrentPeriod());
  const [goals,setGoals]=useState([]);
  const [users,setUsers]=useState([]);
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(null);
  const [showAdd,setShowAdd]=useState(false);
  const [ng,setNg]=useState({user_id:'',description:''});
  const toast=useToast();
  useEffect(()=>{load();},[period]);
  async function load(){setLoading(true);try{const [g,u]=await Promise.all([api.get('/goals?period='+period),api.get('/users')]);setGoals(g);setUsers(u.filter(u=>u.active&&['salesman','supervisor','area_supervisor'].includes(u.role)));}catch{}finally{setLoading(false);}}
  async function evaluate(uid,status){setSaving(uid);try{await api.post('/goals/'+uid+'/'+period+'/evaluate',{status});toast.success('تم');load();}catch(e){toast.error(e.message);}finally{setSaving(null);}}
  async function addGoal(){if(!ng.user_id||!ng.description){toast.error('بيانات مطلوبة');return;}try{await api.post('/goals',{user_id:parseInt(ng.user_id),period,description:ng.description});toast.success('تم');setShowAdd(false);setNg({user_id:'',description:''});load();}catch(e){toast.error(e.message);}}
  return(<>
    <PeriodSelector period={period} onChange={setPeriod}/>
    <button className="btn btn-primary btn-full" style={{marginBottom:12}} onClick={()=>setShowAdd(!showAdd)}>{showAdd?'إلغاء':'+ إضافة هدف خاص'}</button>
    {showAdd&&(<div style={{...card,marginBottom:12}}>
      <div className="input-group" style={{margin:0,marginBottom:10}}><label className="input-label">المستخدم</label><select className="input" value={ng.user_id} onChange={e=>setNg(x=>({...x,user_id:e.target.value}))}><option value="">--</option>{users.map(u=><option key={u.id} value={u.id}>{u.name_ar||u.username}</option>)}</select></div>
      <div className="input-group" style={{margin:0,marginBottom:10}}><label className="input-label">وصف الهدف</label><textarea className="input" rows={3} value={ng.description} onChange={e=>setNg(x=>({...x,description:e.target.value}))} style={{resize:'vertical'}}/></div>
      <button className="btn btn-primary btn-full" onClick={addGoal}>حفظ</button>
    </div>)}
    {loading?<div className="loading-page"><div className="spinner"/></div>:goals.length===0?<div className="empty-state"><h3>لا توجد أهداف</h3></div>:(
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {goals.map(g=>(<div key={g.user_id} style={card}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:6}}>
            <div><div style={{fontSize:14,fontWeight:700}}>{g.name_ar}</div><div style={{fontSize:12,color:'var(--gray-400)'}}>{g.username}</div></div>
            <span style={{fontSize:11,padding:'3px 8px',borderRadius:10,fontWeight:600,background:g.status==='achieved'?'var(--green-100)':g.status==='not_achieved'?'#fee2e2':'var(--gray-100)',color:g.status==='achieved'?'var(--green-700)':g.status==='not_achieved'?'#991b1b':'var(--gray-500)'}}>{g.status==='achieved'?'محقق':g.status==='not_achieved'?'غير محقق':'قيد التقييم'}</span>
          </div>
          <p style={{fontSize:13,color:'var(--gray-600)',marginBottom:10}}>{g.description}</p>
          {g.status==='pending'&&(<div style={{display:'flex',gap:8}}><button className="btn btn-primary btn-sm" style={{flex:1}} disabled={saving===g.user_id} onClick={()=>evaluate(g.user_id,'achieved')}>✓ محقق</button><button className="btn btn-sm" style={{flex:1,background:'#fee2e2',color:'#991b1b'}} disabled={saving===g.user_id} onClick={()=>evaluate(g.user_id,'not_achieved')}>✗ غير محقق</button></div>)}
        </div>))}
      </div>
    )}
  </>);
}

function CommissionTab(){
  const [period,setPeriod]=useState(getCurrentPeriod());
  const [results,setResults]=useState([]);
  const [loading,setLoading]=useState(false);
  const [calc,setCalc]=useState(false);
  const toast=useToast();
  async function calculate(){setCalc(true);try{const r=await api.post('/commission/calculate',{period});toast.success('تم احتساب '+r.calculated+' موظف');load();}catch(e){toast.error(e.message);}finally{setCalc(false);}}
  async function load(){setLoading(true);try{setResults(await api.get('/commission?period='+period));}catch{}finally{setLoading(false);}}
  useEffect(()=>{load();},[period]);
  return(<>
    <PeriodSelector period={period} onChange={setPeriod}/>
    <button className="btn btn-primary btn-full" onClick={calculate} disabled={calc} style={{marginBottom:16}}>{calc?'جاري الاحتساب...':'⚡ احتساب العمولات'}</button>
    {loading?<div className="loading-page"><div className="spinner"/></div>:<div style={{display:'flex',flexDirection:'column',gap:8}}>{results.map(r=>(<div key={r.user_id} style={card}><div style={{display:'flex',alignItems:'center',gap:10}}><div style={{flex:1}}><div style={{fontSize:14,fontWeight:700}}>{r.name_ar}</div><div style={{fontSize:12,color:'var(--gray-400)'}}>{r.branch_name_en}</div></div><div style={{textAlign:'left'}}><div style={{fontSize:16,fontWeight:800,color:'var(--primary)'}}>{parseFloat(r.total_earned||0).toLocaleString('ar',{maximumFractionDigits:0})} ر.س</div><span style={{fontSize:10,padding:'1px 6px',borderRadius:8,fontWeight:600,background:r.status==='paid'?'var(--green-100)':r.status==='locked'?'#dbeafe':'var(--gray-100)',color:r.status==='paid'?'var(--green-700)':r.status==='locked'?'#1e40af':'var(--gray-500)'}}>{r.status==='paid'?'مدفوع':r.status==='locked'?'مقفل':'جاري'}</span></div></div></div>))}</div>}
  </>);
}

function SyncTab(){
  const [period,setPeriod]=useState(getCurrentPeriod());
  const [syncing,setSyncing]=useState(null);
  const [log,setLog]=useState([]);
  const toast=useToast();
  useEffect(()=>{api.get('/netsuite/sync/log').then(setLog).catch(()=>{});},[]);
  async function syncA(){setSyncing('a');try{const r=await api.post('/netsuite/sync/actuals',{period});toast.success('تم مزامنة '+r.summary.qty_by_type+' موظف');setLog(await api.get('/netsuite/sync/log'));}catch(e){toast.error(e.message);}finally{setSyncing(null);}}
  async function syncM(){setSyncing('m');try{await api.post('/netsuite/sync/master',{});toast.success('تمت مزامنة البيانات');setLog(await api.get('/netsuite/sync/log'));}catch(e){toast.error(e.message);}finally{setSyncing(null);}}
  return(<>
    <PeriodSelector period={period} onChange={setPeriod}/>
    <div style={{display:'flex',flexDirection:'column',gap:10,marginBottom:20}}>
      <button className="btn btn-primary" onClick={syncA} disabled={!!syncing}>{syncing==='a'?'جاري...':'🔄 مزامنة بيانات الأداء'}</button>
      <button className="btn btn-secondary" onClick={syncM} disabled={!!syncing}>{syncing==='m'?'جاري...':'📋 مزامنة البيانات الرئيسية'}</button>
    </div>
    <p style={{fontSize:14,fontWeight:700,color:'var(--gray-700)',marginBottom:8}}>سجل المزامنة</p>
    <div style={{display:'flex',flexDirection:'column',gap:8}}>{log.slice(0,10).map(e=>(<div key={e.id} style={{...card,padding:'10px 12px'}}><div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}><div><div style={{fontSize:13,fontWeight:600}}>{e.sync_type==='actuals'?'بيانات الأداء':'بيانات رئيسية'}{e.period?' - '+MONTHS_AR[parseInt(e.period.split('-')[1])-1]:''}</div><div style={{fontSize:11,color:'var(--gray-400)'}}>{new Date(e.started_at).toLocaleString('ar-SA')} · {e.records_processed} سجل</div></div><span style={{fontSize:11,padding:'2px 8px',borderRadius:8,fontWeight:600,background:e.status==='success'?'var(--green-100)':'#fee2e2',color:e.status==='success'?'var(--green-700)':'#991b1b'}}>{e.status==='success'?'نجح':'جزئي'}</span></div></div>))}</div>
  </>);
}
